import { defineMessages } from 'react-intl';


const MESSAGES = defineMessages({
    house: {
        id: 'calculators.HomeTypes.houseType',
        defaultMessage: 'House',
    },
    condo: {
        id: 'calculators.HomeTypes.condoType',
        defaultMessage: 'Condo',
    },
});

const HOME_TYPES = {
    HOUSE: 'house',
    CONDO: 'condo',
};

export { HOME_TYPES };
export default [
    {
        value: HOME_TYPES.HOUSE,
        label: MESSAGES.house,
    },
    {
        value: HOME_TYPES.CONDO,
        label: MESSAGES.condo,
    },
];